export enum WesterosPwmNoteTypeModalMode {
  CREATE = "create",
  VIEW = "view",
  EDIT = "edit",
}
